// PageBreadcrumb - Reusable breadcrumb component with schema markup
// Updated for new URL structure: /parent/child
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { useEffect } from "react";

// Breadcrumb configuration - maps pages to parent categories
// NEW URL STRUCTURE: /yoga-classes/hatha-yoga, /treatments/reiki-healing, etc.
const BREADCRUMB_PARENTS = {
  // Yoga Classes children -> /yoga-classes
  "yoga-classes/hatha-yoga": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  "yoga-classes/yin-yoga": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  "yoga-classes/aerial-yoga": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  "yoga-classes/private-yoga": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  "yoga-classes/beginner-yoga": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  "yoga-classes/children-family-yoga": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  "yoga-classes/sen-yoga": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  "yoga-classes/meditation": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  "yoga-classes/private-yoga-sessions": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  // Legacy slugs (for pages still using old URLs internally)
  "hatha-yoga-frome": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  "yin-yoga-frome": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  "aerial-yoga-frome": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  "private-yoga": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  "beginner-yoga": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  "children-family-yoga-frome": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  "sen-yoga-frome": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  "meditation-frome": { parent: "/yoga-classes", parentName: "Yoga Classes" },
  
  // Treatments children -> /treatments
  "treatments/reiki-healing": { parent: "/treatments", parentName: "Treatments" },
  "treatments/chakra-healing": { parent: "/treatments", parentName: "Treatments" },
  "treatments/swedish-massage": { parent: "/treatments", parentName: "Treatments" },
  "treatments/holistic-treatments": { parent: "/treatments", parentName: "Treatments" },
  // Legacy slugs
  "reiki-healing-frome": { parent: "/treatments", parentName: "Treatments" },
  "chakra-healing-frome": { parent: "/treatments", parentName: "Treatments" },
  "swedish-massage-frome": { parent: "/treatments", parentName: "Treatments" },
  "holistic-treatments-frome": { parent: "/treatments", parentName: "Treatments" },
  
  // Women's Circles children -> /womens-circles
  "womens-circles/frome": { parent: "/womens-circles", parentName: "Women's Circles" },
  "womens-circles-frome": { parent: "/womens-circles", parentName: "Women's Circles" },
  
  // Retreats children -> /retreats
  "retreats/yoga-retreats-uk": { parent: "/retreats", parentName: "Retreats" },
  "retreats/what-to-expect": { parent: "/retreats", parentName: "Retreats" },
  "retreats/packing-list": { parent: "/retreats", parentName: "Retreats" },
  "retreats/benefits": { parent: "/retreats", parentName: "Retreats" },
  "retreats/sound-healing": { parent: "/retreats", parentName: "Retreats" },
  "retreats/beginners": { parent: "/retreats", parentName: "Retreats" },
  "retreats/weekend": { parent: "/retreats", parentName: "Retreats" },
  // Retreats hub page (top level)
  "retreats": { parent: null, parentName: null },
  // Legacy slugs
  "yoga-retreats-uk": { parent: "/retreats", parentName: "Retreats" },
  "what-to-expect-yoga-retreat": { parent: "/retreats", parentName: "Retreats" },
  "yoga-retreat-packing-list": { parent: "/retreats", parentName: "Retreats" },
  "benefits-of-yoga-retreats": { parent: "/retreats", parentName: "Retreats" },
  "sound-healing-retreats-uk": { parent: "/retreats", parentName: "Retreats" },
  "yoga-retreat-for-beginners": { parent: "/retreats", parentName: "Retreats" },
  "weekend-yoga-retreats-uk": { parent: "/retreats", parentName: "Retreats" },
  
  // Location pages -> /areas
  "areas/yoga-bath": { parent: "/areas", parentName: "My Offering Areas" },
  "areas/yoga-trowbridge": { parent: "/areas", parentName: "My Offering Areas" },
  "areas/yoga-warminster": { parent: "/areas", parentName: "My Offering Areas" },
  "areas/yoga-westbury": { parent: "/areas", parentName: "My Offering Areas" },
  "areas/yoga-shepton-mallet": { parent: "/areas", parentName: "My Offering Areas" },
  "areas/yoga-wells": { parent: "/areas", parentName: "My Offering Areas" },
  "areas/yoga-radstock": { parent: "/areas", parentName: "My Offering Areas" },
  "areas/yoga-mells": { parent: "/areas", parentName: "My Offering Areas" },
  "areas/yoga-nunney": { parent: "/areas", parentName: "My Offering Areas" },
  "areas/yoga-beckington": { parent: "/areas", parentName: "My Offering Areas" },
  "areas/yoga-midsomer-norton": { parent: "/areas", parentName: "My Offering Areas" },
  "areas/yoga-bradford-on-avon": { parent: "/areas", parentName: "My Offering Areas" },
  "areas/yoga-somerset": { parent: "/areas", parentName: "My Offering Areas" },
  "areas/yoga-wiltshire": { parent: "/areas", parentName: "My Offering Areas" },
  // Legacy slugs
  "yoga-bath": { parent: "/areas", parentName: "My Offering Areas" },
  "yoga-trowbridge": { parent: "/areas", parentName: "My Offering Areas" },
  "yoga-warminster": { parent: "/areas", parentName: "My Offering Areas" },
  "yoga-westbury": { parent: "/areas", parentName: "My Offering Areas" },
  "yoga-shepton-mallet": { parent: "/areas", parentName: "My Offering Areas" },
  "yoga-wells": { parent: "/areas", parentName: "My Offering Areas" },
  "yoga-radstock": { parent: "/areas", parentName: "My Offering Areas" },
  "yoga-mells": { parent: "/areas", parentName: "My Offering Areas" },
  "yoga-nunney": { parent: "/areas", parentName: "My Offering Areas" },
  "yoga-beckington": { parent: "/areas", parentName: "My Offering Areas" },
  "yoga-midsomer-norton": { parent: "/areas", parentName: "My Offering Areas" },
  "yoga-bradford-on-avon": { parent: "/areas", parentName: "My Offering Areas" },
  "yoga-somerset": { parent: "/areas", parentName: "My Offering Areas" },
  "yoga-wiltshire": { parent: "/areas", parentName: "My Offering Areas" },
  
  // Service + Location combo pages -> /areas/[location]/[service]
  // Bath
  "areas/yoga-bath/hatha-yoga": { parent: "/areas/yoga-bath", parentName: "Yoga in Bath" },
  "areas/yoga-bath/yin-yoga": { parent: "/areas/yoga-bath", parentName: "Yoga in Bath" },
  "areas/yoga-bath/private-yoga": { parent: "/areas/yoga-bath", parentName: "Yoga in Bath" },
  // Trowbridge
  "areas/yoga-trowbridge/hatha-yoga": { parent: "/areas/yoga-trowbridge", parentName: "Yoga in Trowbridge" },
  "areas/yoga-trowbridge/yin-yoga": { parent: "/areas/yoga-trowbridge", parentName: "Yoga in Trowbridge" },
  "areas/yoga-trowbridge/private-yoga": { parent: "/areas/yoga-trowbridge", parentName: "Yoga in Trowbridge" },
  // Warminster
  "areas/yoga-warminster/hatha-yoga": { parent: "/areas/yoga-warminster", parentName: "Yoga in Warminster" },
  "areas/yoga-warminster/yin-yoga": { parent: "/areas/yoga-warminster", parentName: "Yoga in Warminster" },
  "areas/yoga-warminster/private-yoga": { parent: "/areas/yoga-warminster", parentName: "Yoga in Warminster" },
  // Wells
  "areas/yoga-wells/hatha-yoga": { parent: "/areas/yoga-wells", parentName: "Yoga in Wells" },
  "areas/yoga-wells/yin-yoga": { parent: "/areas/yoga-wells", parentName: "Yoga in Wells" },
  "areas/yoga-wells/private-yoga": { parent: "/areas/yoga-wells", parentName: "Yoga in Wells" },
  // Radstock
  "areas/yoga-radstock/hatha-yoga": { parent: "/areas/yoga-radstock", parentName: "Yoga in Radstock" },
  "areas/yoga-radstock/yin-yoga": { parent: "/areas/yoga-radstock", parentName: "Yoga in Radstock" },
  "areas/yoga-radstock/private-yoga": { parent: "/areas/yoga-radstock", parentName: "Yoga in Radstock" },
  // Westbury
  "areas/yoga-westbury/hatha-yoga": { parent: "/areas/yoga-westbury", parentName: "Yoga in Westbury" },
  "areas/yoga-westbury/yin-yoga": { parent: "/areas/yoga-westbury", parentName: "Yoga in Westbury" },
  "areas/yoga-westbury/private-yoga": { parent: "/areas/yoga-westbury", parentName: "Yoga in Westbury" },
  // Shepton Mallet
  "areas/yoga-shepton-mallet/hatha-yoga": { parent: "/areas/yoga-shepton-mallet", parentName: "Yoga in Shepton Mallet" },
  "areas/yoga-shepton-mallet/yin-yoga": { parent: "/areas/yoga-shepton-mallet", parentName: "Yoga in Shepton Mallet" },
  "areas/yoga-shepton-mallet/private-yoga": { parent: "/areas/yoga-shepton-mallet", parentName: "Yoga in Shepton Mallet" },
  // Legacy service+location slugs (redirects)
  "hatha-yoga-bath": { parent: "/areas/yoga-bath", parentName: "Yoga in Bath" },
  "yin-yoga-bath": { parent: "/areas/yoga-bath", parentName: "Yoga in Bath" },
  "private-yoga-bath": { parent: "/areas/yoga-bath", parentName: "Yoga in Bath" },
  "hatha-yoga-trowbridge": { parent: "/areas/yoga-trowbridge", parentName: "Yoga in Trowbridge" },
  "yin-yoga-trowbridge": { parent: "/areas/yoga-trowbridge", parentName: "Yoga in Trowbridge" },
  "private-yoga-trowbridge": { parent: "/areas/yoga-trowbridge", parentName: "Yoga in Trowbridge" },
  "hatha-yoga-warminster": { parent: "/areas/yoga-warminster", parentName: "Yoga in Warminster" },
  "yin-yoga-warminster": { parent: "/areas/yoga-warminster", parentName: "Yoga in Warminster" },
  "private-yoga-warminster": { parent: "/areas/yoga-warminster", parentName: "Yoga in Warminster" },
  "hatha-yoga-wells": { parent: "/areas/yoga-wells", parentName: "Yoga in Wells" },
  "yin-yoga-wells": { parent: "/areas/yoga-wells", parentName: "Yoga in Wells" },
  "private-yoga-wells": { parent: "/areas/yoga-wells", parentName: "Yoga in Wells" },
  "hatha-yoga-radstock": { parent: "/areas/yoga-radstock", parentName: "Yoga in Radstock" },
  "yin-yoga-radstock": { parent: "/areas/yoga-radstock", parentName: "Yoga in Radstock" },
  "private-yoga-radstock": { parent: "/areas/yoga-radstock", parentName: "Yoga in Radstock" },
  "hatha-yoga-westbury": { parent: "/areas/yoga-westbury", parentName: "Yoga in Westbury" },
  "yin-yoga-westbury": { parent: "/areas/yoga-westbury", parentName: "Yoga in Westbury" },
  "private-yoga-westbury": { parent: "/areas/yoga-westbury", parentName: "Yoga in Westbury" },
  "hatha-yoga-shepton-mallet": { parent: "/areas/yoga-shepton-mallet", parentName: "Yoga in Shepton Mallet" },
  "yin-yoga-shepton-mallet": { parent: "/areas/yoga-shepton-mallet", parentName: "Yoga in Shepton Mallet" },
  "private-yoga-shepton-mallet": { parent: "/areas/yoga-shepton-mallet", parentName: "Yoga in Shepton Mallet" },
};

// Generate BreadcrumbList schema
const generateBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": `https://annelielily.com${item.path}`
  }))
});

const PageBreadcrumb = ({ currentPage, currentSlug }) => {
  const config = BREADCRUMB_PARENTS[currentSlug];
  
  // Build breadcrumb items
  const items = [{ name: "Home", path: "/" }];
  
  if (config) {
    // Add parent
    items.push({ name: config.parentName, path: config.parent });
  }
  
  // Add current page
  const currentPath = currentSlug.startsWith('/') ? currentSlug : `/${currentSlug}`;
  items.push({ name: currentPage, path: currentPath });
  
  // Inject schema
  useEffect(() => {
    const schema = generateBreadcrumbSchema(items);
    const id = `breadcrumb-schema-${currentSlug.replace(/\//g, '-')}`;
    
    // Remove existing
    const existing = document.getElementById(id);
    if (existing) existing.remove();
    
    // Add new
    const script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
    
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [currentSlug, items]);
  
  return (
    <nav 
      aria-label="Breadcrumb" 
      className="pt-24 pb-3 px-6 md:px-12 bg-cream/50 border-b border-gold/10"
      data-testid="page-breadcrumb"
    >
      <ol className="max-w-6xl mx-auto flex items-center gap-2 text-sm">
        {items.map((item, index) => (
          <li key={item.path} className="flex items-center gap-2">
            {index > 0 && (
              <ChevronRight className="w-4 h-4 text-neutral-400" />
            )}
            {index === items.length - 1 ? (
              // Current page (not a link)
              <span className="text-neutral-600 font-medium" aria-current="page">
                {item.name}
              </span>
            ) : index === 0 ? (
              // Home with icon
              <Link 
                to={item.path} 
                className="text-gold hover:text-gold-dark transition-colors flex items-center gap-1"
              >
                <Home className="w-4 h-4" />
                <span className="sr-only">{item.name}</span>
              </Link>
            ) : (
              // Parent links
              <Link 
                to={item.path} 
                className="text-gold hover:text-gold-dark transition-colors"
              >
                {item.name}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default PageBreadcrumb;
export { BREADCRUMB_PARENTS, generateBreadcrumbSchema };
